import { memo } from "react";
import { Grid, Input, Popup, Icon } from "semantic-ui-react";
import { HandleInputChange } from "../../../../../../custom-hooks/form/types";

type GatewayIPProps = {
  onChange: HandleInputChange;
  gatewayIp?: string;
};

const GatewayIP = ({ onChange, gatewayIp }: GatewayIPProps) => {
  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter padding-top-30"
      >
        <h5>
          Gateway IP
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            Optional Gateway IP: Enter a valid IP or set the Gateway to
            disabled.
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="padding-top-30">
        <Input
          value={gatewayIp}
          className="select-box full"
          onChange={onChange}
          name="gatewayIp"
        />
      </Grid.Column>
    </>
  );
};

export default memo(GatewayIP);
